'use strict';

module.exports = require('./is-implemented')()
	? Object.keys
	: require('./shim');



//////////////////
// WEBPACK FOOTER
// ./~/event-emitter/~/es5-ext/object/keys/index.js
// module id = 20
// module chunks = 0